<form class="login-form" [formGroup]="forgotFormGrp">
  @if (errorMessage) {
    <div class="error-container">
      {{this.errorMessage}}
    </div>
  }
  <div class="div-info">
    <span>
      {{'common.dont_worry_weve_got_your_back!_just_enter_your_email_address_and_well_send_you_a_link_with_which_you_can_reset_your_password' | translate}}
    </span>
  </div>
  <div class="row">
    <div class="required col-sm-12 form-group">
      <label for="emailAddressInput">
        <span>{{'common.email_address' | translate}}</span>
      </label>
      <input id="emailAddressInput" autocomplete="off"  type="email" matInput formControlName="email" [errorStateMatcher]="matcher" placeholder="Ex. pat@example.com">
      <!-- <mat-hint>Errors appear instantly!</mat-hint> -->
      @if (forgotFormGrp.get('email')?.hasError('email') && !forgotFormGrp.get('email')?.hasError('required')) {
        <mat-error>
          {{ "common.please_enter_a_valid_email_address" | translate }}
        </mat-error>
      }
    </div>
  </div>

  <div class="flex-column-center">
    <uw-button [loading]="buttonLoading" (click)="forgotPassword()"  btnLabel="Send Request"></uw-button>
    <button title="{{'auth.return_to_sign_in' | translate}}" mat-button [uwRouterLink]="['/donor', {outlets: {sidebar: ['login']}}]">{{'auth.return_to_sign_in' | translate}}</button>
  </div>
</form>
